import React from "react";
import { Button } from "react-bootstrap";

const suggestions = [
  "Peux-tu m’aider à organiser un voyage culturel en Italie pour 8 jours ?",
  "Je souhaite voyager avec deux enfants, que me recommandes-tu comme destination ?",
  "Trouve-moi un vol pas trop cher depuis Paris pour un week-end dans 3 semaines à Barcelone",
  "Quelles sont les activités incontournables à faire au Japon ?",
  //   "Voici mes dates : du 15 au 25 juillet. Tu peux me construire un itinéraire optimisé ?",
  "Quels sont les meilleurs spots pour surfer en Europe ?",
  "Comment me rendre de Rome à Florence en train ?",
  "Comment me rendre en ferry en Corse ?",
];

interface Props {
  onSelect: (text: string) => void;
}

const SuggestionBubbles: React.FC<Props> = ({ onSelect }) => {
  return (
    <div className="d-flex flex-wrap gap-2 mt-3">
      {suggestions.map((text, idx) => (
        <Button
          key={idx}
          variant="outline-primary"
          className="rounded-pill"
          size="sm"
          onClick={() => onSelect(text)}
        >
          {text}
        </Button>
      ))}
    </div>
  );
};

export default SuggestionBubbles;
